import React from "react";
import { Spinner } from "reactstrap";

/*
  Fila de acciones del detalle: los cuatro botones del diseño más el resumen de cortes.
  "Imprimir salida" y "Ver recorrido" todavía no están conectados y avisan al pulsarlos,
  igual que hace la app de referencia.
*/
const Accion = ({ icon, label, onClick, loading, disabled, hint }) => (
  <button
    type="button"
    className="operador-accion"
    onClick={onClick}
    disabled={loading || disabled}
    title={hint}
  >
    <span className="operador-accion-icon">
      {loading ? <Spinner size="sm" /> : <i className={`mdi mdi-${icon}`}></i>}
    </span>
    <span style={{ minWidth: 0 }}>
      <span className="d-block text-truncate" style={{ fontSize: "13.5px", fontWeight: 600 }}>{label}</span>
      {hint && <span className="d-block text-truncate" style={{ fontSize: "11px", color: "#777a89" }}>{hint}</span>}
    </span>
  </button>
);

const AccionesSalida = ({ salida, buscando, onBuscarTiempos, onBoletera, cargandoCortes, onCortes, onProximamente }) => {
  // El motor no puede reconciliar una salida cuyos datos llegan de un proveedor externo
  const remota = !!salida.remote_data;

  return (
    <div className="operador-acciones">
      <Accion
        icon="printer"
        label="Imprimir salida"
        onClick={() => onProximamente("Imprimir salida")}
      />
      <Accion
        icon="magnify"
        label="Buscar tiempos"
        loading={buscando}
        disabled={remota}
        hint={remota ? "No disponible: datos de proveedor externo" : "Vuelve a consultar el GPS"}
        onClick={onBuscarTiempos}
      />
      <Accion
        icon="map-outline"
        label="Ver recorrido"
        onClick={() => onProximamente("Ver recorrido")}
      />
      <Accion
        icon="ticket-confirmation-outline"
        label="Boletera"
        onClick={onBoletera}
      />
      <Accion
        icon="receipt"
        label="Imprimir cortes"
        loading={cargandoCortes}
        hint="Resumen de cortes del día"
        onClick={onCortes}
      />
    </div>
  );
};

export default AccionesSalida;
